// The reader's clock: 24-hour by default — every Satori app prints a fixed "HH:mm" — and 12-hour
// only when the ACCOUNT says so explicitly (`display_settings` / `use_military_time` = "false",
// set in Configuración › Pantalla or the old webapp). An account that never chose keeps the apps'
// clock: Mattermost's own default is 12-hour, and adopting it would make the web disagree with the
// Mac and phones for everyone who never touched the setting.
let twelveHour = false;
let periods: [string, string] = ['a. m.', 'p. m.'];

export function setTwelveHour(on: boolean, am = 'a. m.', pm = 'p. m.'): void {
  twelveHour = on;
  periods = [am, pm];
}

export function isTwelveHour(): boolean {
  return twelveHour;
}

/** The account preference → whether to print 12-hour times. */
export function twelveHourFromPreference(useMilitaryTime: string | null | undefined): boolean {
  return useMilitaryTime === 'false';
}

function pad2(n: number): string {
  return n < 10 ? '0' + n : String(n);
}

/** "14:05", or "2:05 p. m." under a 12-hour account. */
export function clock(hour: number, minute: number): string {
  if (!twelveHour) return pad2(hour) + ':' + pad2(minute);
  const h = hour % 12 === 0 ? 12 : hour % 12;
  return `${h}:${pad2(minute)} ${hour < 12 ? periods[0] : periods[1]}`;
}

/** Intl options for the few places that format with Intl directly. */
export function hourCycleOptions(): { hourCycle: 'h12' | 'h23' } {
  return { hourCycle: twelveHour ? 'h12' : 'h23' };
}
